// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b9a60b43","46":"8fa6ea4a","216":"c33054e5","242":"bef94222","340":"5bebd3ed","397":"a78805b8","963":"a2b44c57"}[chunkId] + ".chunk.js";
};